import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "../UiStyle/TestimonialStyles.css";
import SectionTitle from "../SectionTitle/SectionTitle";
import axios from "axios";

export default function TestimonialSlider() {
  const [testimonials, setTestimonials] = useState([]);

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button className="slick-arrow slick-next" onClick={onClick}>
        &gt;
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button className="slick-arrow slick-prev" onClick={onClick}>
        &lt;
      </button>
    );
  };

  const fetchTestimonial = async () => {
    try {
      const response = await axios.get(
        "https://apis.chemistforall.com/v1/auth/website-reviews"
      );
      setTestimonials(response.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch testimonials:", error);
    }
  };

  useEffect(() => {
    fetchTestimonial();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  function truncateWords(text, limit) {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= limit) {
      return text;
    }
    return words.slice(0, limit).join(" ") + "...";
  }

  return (
    <div className="container website-review mt-50">
      <SectionTitle
        sTitle={"What our client says"}
        sClass={"heading-title-s2"}
      />
      <div className="row">
        {/* Ratings Column */}
        <div className="col-md-3 d-flex align-items-center justify-content-center mb-4">
          <div className="text-center">
            <h1 className="display-5">4.9</h1>
            <div className="text-warning mb-2">
              {[...Array(5)].map((_, i) => (
                <i
                  key={i}
                  className="fas fa-star"
                  style={{ fontSize: "30px", marginRight: "5px" }}
                />
              ))}
            </div>
            <p className="mb-0" style={{ fontSize: 18, color: "black" }}>
              500+ reviews
            </p>
            <a href="#" className="text-primary">
              (See All Reviews)
            </a>
          </div>
        </div>

        {/* Testimonials Slider Column */}
        <div className="col-md-9">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="px-2 website-card">
                <div
                  className="border rounded p-3 h-100 position-relative d-flex flex-column"
                  style={{ borderColor: "#84b703" }}
                >
                  <h5 className="fw-bold" style={{ color: "#84b703" }}>
                    {testimonial.user_name}
                  </h5>
                  <div className="text-warning mb-2">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`fas fa-star ${
                          i < Math.round(testimonial.ratings)
                            ? "text-warning"
                            : "text-muted"
                        }`}
                      />
                    ))}
                  </div>
                  <h6 className="fw-bold">{testimonial.review_title}</h6>
                  <p className="text-muted">
                    "{truncateWords(testimonial.review_description, 30)}"
                  </p>

                  {/* Bottom area */}
                  <div className="mt-auto pt-2">
                    <hr />
                    <p className="text-muted small mb-0">
                      {testimonial.review_date}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}